import { Box, Stack, Typography } from "@mui/material";
import style from "./style";

interface IProps {
  distance: string;
  duration: string;
}

const DistanceAndDuration = ({ distance, duration }: IProps) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="center"
      alignItems="center"
    >
      <Box sx={style.box}>
        <Typography>{distance}</Typography>
      </Box>
      <Box sx={style.box}>
        <Typography>{duration}</Typography>
      </Box>
    </Stack>
  );
};

export default DistanceAndDuration;
